<template>
  <div class="relative p-4 border rounded-10 border-slate-300 dark:border-zinc-700 flex items-center gap-4" data-testid="transcription-upselling-inline">
    <p class="dark:text-zinc-500">
      <template v-if="isNewPlan">Transform videos into instant insights. Automate SOPs, meeting notes, training materials, and more.</template>
      <template v-else>Automatically add titles, descriptions, and transcriptions to your videos to provide greater context & enhanced searchability.</template>
    </p>
    <Button v-if="isNewPlan" type="solid" variant="pink-gradient" icon="general.stars" href="/account/plans">Explore our plans</Button>
    <Button v-else type="solid" variant="pink-gradient" icon="general.stars" href="/account/plans">Get AI add-on</Button>
    <Button type="link" variant="black" icon="general.crossLight" @click.prevent="emit('close')" />
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/storybook';

defineProps<{
  isNewPlan?: boolean;
}>();

const emit = defineEmits(['close']);
</script>

<style scoped></style>
